import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  annotationItem: {
    display: 'flex',
    flexDirection: 'column',
    borderBottom: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
    paddingBottom: spacing(Theme.Spacing.Medium),
  },
  firstAnnotationItem: {
    paddingTop: spacing(Theme.Spacing.Medium),
  },
  content: {
    display: 'flex',
    width: spacing(325),
    gap: spacing(12),
  },
  wrapper: {
    whiteSpace: 'break-spaces',
    flex: 1,
    minWidth: 0,
  },
  bodyContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  raw: {
    direction: 'raw',
    display: 'flex',
    whiteSpace: 'nowrap',
    gap: spacing(10),
  },
  icon: {
    display: 'flex',
    height: spacing(32),
    width: spacing(32),
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Theme.Colors.Primary.Base,
  },
  title: {
    display: 'flex',
    color: Theme.Colors.Grayscale.Eighty,
    fontSize: Theme.Typography.FontSize.XXSmall,
    fontWeight: Theme.Typography.FontWeight.Medium,
    fontFamily: Theme.Typography.FontFamily.DMSans,
    lineHeight: '18px',
  },
  description: {
    display: '-webkit-box',
    width: '100%',
    margin: 0,
    padding: 0,
    fontSize: Theme.Typography.FontSize.XXSmall,
    fontFamily: Theme.Typography.FontFamily.Roboto,
    fontWeight: Theme.Typography.FontWeight.Small,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    lineHeight: '16.41px',
    wordBreak: 'break-word',
    maxWidth: '100%',
    '-webkit-box-orient': ' vertical',
    '-webkit-line-clamp': 4,
  },
  link: {
    display: 'flex',
    alignSelf: 'flex-start',
    justifyContent: 'flex-start',
    minWidth: 'unset',
    width: 'fit-content',
    textAlign: 'left',
    fontWeight: Theme.Typography.FontWeight.Small,
    padding: spacing(0),
    fontSize: Theme.Typography.FontSize.Tiny,
    color: Theme.Colors.Primary.Base,
    textDecoration: 'underline',
    paddingTop: spacing(5),
    paddingBottom: 0,
    '&.MuiButton-root': {
      display: 'flex',
      justifyContent: 'flex-start',
      paddingLeft: 0,
      paddingRight: 0,
      marginLeft: 0,
    },
    '& .MuiButton-label': {
      justifyContent: 'flex-start',
    },
  },
  date: {
    display: 'flex',
    fontSize: Theme.Typography.FontSize.Tiny,
    color: Theme.Colors.Grayscale.SixtyFour,
  },
  buttons: {
    position: 'absolute',
    right: 0,
    justifySelf: 'end',
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    height: '4px',
    padding: spacing(0),
  },
  span: {
    fontWeight: 'bold',
    fontSize: '14px',
  },
  spanMesage: {
    fontSize: Theme.Typography.FontSize.XXSmall,
  },
  tagsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: spacing(8),
    marginTop: spacing(14),
  },
  tag: {
    borderRadius: spacing(24),
    minHeight: spacing(18),
    display: 'inline-flex',
    alignItems: 'center',
    textTransform: 'none',
    fontFamily: [Theme.Typography.FontFamily.Roboto, 'sans-serif'],
    padding: spacing(4, 9),
    fontSize: Theme.Typography.FontSize.Tiny,
    lineHeight: '112.5%',
    cursor: 'default',
    whiteSpace: 'nowrap',
    backgroundColor: Theme.Colors.Grayscale.Four,
    color: Theme.Colors.Grayscale.SixtyFour,
  },
  statusTag: {
    borderRadius: spacing(24),
    height: spacing(24),
    width: 'fit-content',
    textTransform: 'none',
    padding: '4px 8px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    backgroundColor: Theme.Colors.Grayscale.Four,
    color: Theme.Colors.Grayscale.SixtyFour,
    display: 'flex',
    flexDirection: 'row',
    gap: spacing(4),
    fontFamily: [Theme.Typography.FontFamily.Roboto, 'sans-serif'],
    fontSize: Theme.Typography.FontSize.Tiny,
    lineHeight: '112.5%',
    marginTop: spacing(4),
    marginBottom: spacing(4),
  },
  styleDisabled: {
    fill: Theme.Colors.Grayscale.Eighty,
    cursor: 'pointer',
    width: '16.33px',
    height: '16.23px',
    border: '1.5px',
  },
  styleEnabled: {
    cursor: 'pointer',
    color: Theme.Colors.Yellow.Base,
  },
  justifiedDelay: {
    backgroundColor: Theme.Colors.Yellow.Base,
  },
  paymentAnticipation: {
    backgroundColor: Theme.Colors.Green.Base,
  },
  helpRequest: {
    backgroundColor: Theme.Colors.Red.Base,
  },
  senderName: {
    color: Theme.Colors.Grayscale.Eighty,
  },
  helpRequestIcon: {
    fontSize: '14px',
  },
  editIcon: {
    fill: Theme.Colors.Grayscale.Eighty,
    width: spacing(20),
    height: spacing(20),
  },
  trashIcon: {
    fill: Theme.Colors.Red.Base,
    width: spacing(20),
    height: spacing(20),
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(8),
    minHeight: spacing(40),
    padding: spacing(8, 16),
  },
  menuItemIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: spacing(20),
    height: spacing(20),
    flexShrink: 0,
  },
  menuItemLabel: {
    margin: 0,
    lineHeight: 1,
    display: 'flex',
    alignItems: 'center',
  },
  edit: {
    fontFamily: Theme.Typography.FontFamily.Inter,
    fontSize: Theme.Typography.FontSize.XXSmall,
    fontWeight: Theme.Typography.FontWeight.Medium,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    textAlign: 'left',
  },
  delete: {
    fontFamily: Theme.Typography.FontFamily.Inter,
    fontSize: Theme.Typography.FontSize.XXSmall,
    fontWeight: Theme.Typography.FontWeight.Medium,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    textAlign: 'left',
    color: Theme.Colors.Red.Base,
  },
  disabledMenuItemWrapper: {
    display: 'block',
    width: '100%',
  },
  readOnlyActionIcon: {
    fill: Theme.Colors.Grayscale.SixtyFour,
    opacity: 0.6,
  },
  readOnlyActionLabel: {
    color: Theme.Colors.Grayscale.SixtyFour,
    opacity: 0.6,
  },
}))
